var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "report-tab-layout",
    {
      scopedSlots: _vm._u([
        {
          key: "card-footer",
          fn: function () {
            return [
              _c("report-toolbar", {
                attrs: {
                  "set-default-props": _vm.setDefaultButtonProps,
                  "report-props": Object.assign({}, _vm.runningReport, {
                    disabled: _vm.$v.$invalid,
                  }),
                },
                on: {
                  "reset-to-default": _vm.resetToDefaultValues,
                  "set-default": _vm.setDefaultValues,
                  "run-report": _vm.handleRunReport,
                  "clear-selection": _vm.handleClearSelection,
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.loading
        ? _c("risk-level-loader")
        : _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("application-reports.level")) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                              _vm._v(" "),
                              !_vm.CURRENT_ACCOUNT_IS_BROKER
                                ? _c("icon", {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        value: {
                                          title: _vm.$t(
                                            "application-reports.risk-level.selectAgentMessage"
                                          ),
                                        },
                                        expression:
                                          "{\n                title: $t('application-reports.risk-level.selectAgentMessage')\n              }",
                                        modifiers: { hover: true },
                                      },
                                    ],
                                    staticClass: "text-primary clickable ml-1",
                                    attrs: { name: "info-circle" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-level", {
                            attrs: {
                              "selected-level":
                                _vm.riskLevelValues.selectedLevel,
                            },
                            on: {
                              "update:selectedLevel": function ($event) {
                                return _vm.$set(
                                  _vm.riskLevelValues,
                                  "selectedLevel",
                                  $event
                                )
                              },
                              "update:selected-level": function ($event) {
                                return _vm.$set(
                                  _vm.riskLevelValues,
                                  "selectedLevel",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showAgentsSelect
                        ? _c(
                            "b-col",
                            {
                              staticClass: "mb-3",
                              attrs: { cols: "12", sm: "6" },
                            },
                            [
                              _c(
                                "h6",
                                {
                                  staticClass:
                                    "bold mb-1 form-title font-sm text-capitalize",
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$tc("global.doorr.agent", 1)) +
                                      "\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c("agents-select", {
                                    attrs: {
                                      id: "select-agents-reports",
                                      value: _vm.riskLevelValues.selectedAgents,
                                      "select-options": _vm.options,
                                      "extra-select-data": [
                                        _vm.allAgentsOption,
                                      ],
                                      "default-value":
                                        _vm.riskLevelValues.selectedAgents,
                                      label: "",
                                      "has-checkboxes": "",
                                      "space-classes":
                                        "form-group-material form-group-material-no-label",
                                      "close-on-select-all": "",
                                    },
                                    on: { change: _vm.handleSelectAgentChange },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-reports.risk-level.name"
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-risk-level", {
                            attrs: {
                              "selected-risk-levels":
                                _vm.riskLevelValues.selectedRiskLevels,
                              multiple: "",
                              clearable: true,
                              action: "clear",
                            },
                            on: {
                              "update:selectedRiskLevels": function ($event) {
                                return _vm.$set(
                                  _vm.riskLevelValues,
                                  "selectedRiskLevels",
                                  $event
                                )
                              },
                              "update:selected-risk-levels": function ($event) {
                                return _vm.$set(
                                  _vm.riskLevelValues,
                                  "selectedRiskLevels",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("b-col", {
                        staticClass: "mb-3",
                        attrs: { cols: "12", sm: "6" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("application-reports.format")) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-format", {
                            attrs: {
                              "selected-format":
                                _vm.riskLevelValues.selectedFormat,
                            },
                            on: {
                              "update:selectedFormat": function ($event) {
                                return _vm.$set(
                                  _vm.riskLevelValues,
                                  "selectedFormat",
                                  $event
                                )
                              },
                              "update:selected-format": function ($event) {
                                return _vm.$set(
                                  _vm.riskLevelValues,
                                  "selectedFormat",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-reports.applicationStatus"
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-application-status", {
                            attrs: {
                              clearable: true,
                              multiple: "",
                              "selected-application-status":
                                _vm.riskLevelValues.selectedApplicationStatus,
                              action: "clear",
                            },
                            on: {
                              "update:selectedApplicationStatus": function (
                                $event
                              ) {
                                return _vm.$set(
                                  _vm.riskLevelValues,
                                  "selectedApplicationStatus",
                                  $event
                                )
                              },
                              "update:selected-application-status": function (
                                $event
                              ) {
                                return _vm.$set(
                                  _vm.riskLevelValues,
                                  "selectedApplicationStatus",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", lg: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-reports.applications-summary.dateType"
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "material-input",
                            {
                              staticClass: "no-border",
                              attrs: { id: "select-date-type", "no-label": "" },
                              model: {
                                value: _vm.riskLevelValues.dateType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.riskLevelValues, "dateType", $$v)
                                },
                                expression: "riskLevelValues.dateType",
                              },
                            },
                            [
                              _c("v-select-field", {
                                staticClass: "search-input w-100 simple-dd",
                                attrs: {
                                  options: _vm.dateTypeOptions,
                                  placeholder: _vm.$t(
                                    "global.actions.chooseOption"
                                  ),
                                  value: _vm.riskLevelValues.dateType,
                                  clearable: false,
                                  label: "text",
                                  "default-value": _vm.riskLevelValues.dateType,
                                },
                                on: {
                                  "option:selected": function (ref) {
                                    var id = ref.id

                                    return (_vm.riskLevelValues.dateType = id)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", lg: "6" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3",
                                  attrs: { cols: "12", sm: "6" },
                                },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "form-title font-sm mb-0" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "application-reports.dateFrom"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                      _c("input-required-indicator"),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    [
                                      _c("date-section", {
                                        attrs: {
                                          id: "application-summary-date-from",
                                          "maturity-date": "",
                                          placeholder: "YYYY-MM-DD",
                                          "max-date":
                                            _vm.riskLevelValues.dateTo,
                                        },
                                        model: {
                                          value: _vm.riskLevelValues.dateFrom,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.riskLevelValues,
                                              "dateFrom",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "riskLevelValues.dateFrom",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3",
                                  attrs: { cols: "12", sm: "6" },
                                },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "form-title font-sm mb-0" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("application-reports.dateTo")
                                          ) +
                                          "\n                "
                                      ),
                                      _c("input-required-indicator"),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    [
                                      _c("date-section", {
                                        attrs: {
                                          id: "application-summary-date-to",
                                          "maturity-date": "",
                                          placeholder: "YYYY-MM-DD",
                                          "min-date":
                                            _vm.riskLevelValues.dateFrom,
                                        },
                                        model: {
                                          value: _vm.riskLevelValues.dateTo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.riskLevelValues,
                                              "dateTo",
                                              $$v
                                            )
                                          },
                                          expression: "riskLevelValues.dateTo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }